import script from "./FieldControlFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldControlFile.vue?vue&type=script&setup=true&lang=ts"

import "./FieldControlFile.vue?vue&type=style&index=0&id=2eab0c3c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eab0c3c"]])

export default __exports__